
const AppSettings = {
  appTitle: 'st-ives-d8044',
  siteAdmin: '',
  baseUrl: 'https://europe-west2-st-ives-d8044.cloudfunctions.net/functions/',
  showFeedbackButton: false,
  showPostcodeFilter: false,
  showHelp: false,
  showUser: true,
  enableFilter: false,
  enableEntitySearch: false,
  enableChildrenCount: false,
  enableEntityPopup: true,
  parentChange: false,
  feedbackType: 'form',
  showMapKey: false,
  sateliteView: false,
  layerVisibilityToggle: false,
  imageMapKey: 'https://firebasestorage.googleapis.com/v0/b/pinpoint-pollokshaws.appspot.com/o/Toggle-key.png?alt=media&token=e161b8e4-b8a6-4d42-97fd-e6cc72ce74e1',
  imageMapKey: 'key.png',
  mapConfig: {
    accessToken:
      "pk.eyJ1IjoiY3JlYXRpdmUtZGVzaWduIiwiYSI6ImNqYXY0d3h2eTZ5M2syd2w5eWo3Ymd5bGIifQ.cYdELtP5xXELeUZ0p_cS_g",
    templatename: "mapbox://styles/creative-design/ckps6qr6y2ifz17o4qdq0lo1m/draft", ///draft", //"mapbox://styles/mapbox/light-v10", //"mapbox://styles/mapbox/basic-v9?optimize=true",
    startLocation: [-0.0911276, 52.3344633],//[-0.457619, 51.4712667],52.3344633,-0.0911276
    startZoom: 12,
    startPitch: 0

  },

};

export default AppSettings;

